import { render, staticRenderFns } from "./WhPhotos.vue?vue&type=template&id=36fab25e&"
import script from "./WhPhotos.vue?vue&type=script&lang=js&"
export * from "./WhPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports